
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(308|516|887)|59(28|66)|6(017|418|910)|8(124|266|544|867)|7(325|431|483|752|777)|3(72[24]|552|816)|1456|1979|4434|9252|9397)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
